/**
 * Created by Ning Jiang on 2021-05-06.
 */

export enum ReelState {
    IDLE = "idle",
    INACTIVE = "inactive",

    // Spin states.
    START = "start",
    SPIN = "spin",
    STOPPING = "stopping",
    BOUNCE = "bounce",
    STOPPED = "stopped",
    NUDGE = "nudge",
}

export interface IReelStateEventData {
    reelId:number;
    newState:ReelState;
    oldState:ReelState;
}